<template>
  <Nav></Nav>
  <Home></Home>
  <MovinGuy></MovinGuy>
  <About></About>
  <MovinGuy class="mb-5 my-md-5"></MovinGuy>
  <Path></Path>
  <MovinGuy class="my-5"></MovinGuy>
  <Services></Services>
  <MovinGuy class="my-5"></MovinGuy>
  <Projects></Projects>
  <MovinGuy class="mt-5"></MovinGuy>
  <Colab></Colab>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Colab from "@/components/Colab.vue";
import Projects from "@/components/Projects.vue";
import Services from "@/components/Services.vue";
import Path from "@/components/Path.vue";
import About from "@/components/About.vue";
import MovinGuy from "@/components/MovinGuy.vue";
import Home from "@/views/Home.vue";
export default {
  components: {
    Nav,
    Colab,
    Projects,
    Services,
    Path,
    About,
    MovinGuy,
    Home,
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Htet Aung Hlaing - portfolio",
    // all titles will be injected into this template
    titleTemplate: "%s | My Awesome Webapp",
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
